import moment from 'moment';
import { weeksBackwards } from '$src/hooks/useEventsChartData';

const MAX_Y_AXIS = 10;

export const chartOptions = {
  scales: {
    y: {
      min: 0,
      max: (context) => {
        const dataPoints = context.chart.data.datasets[0].data;
        const isEmpty = dataPoints.every((value) => value === 0);

        return isEmpty ? MAX_Y_AXIS : undefined;
      },
      beginAtZero: true,
      ticks: {
        precision: 0,
      },
      grace: '10%',
    },
    x: {
      ticks: {
        callback: (_, index) => {
          const week = moment(weeksBackwards[index]);

          const startDate = week.startOf('week').format('DD');
          const endDate = week.endOf('week').format('DD MMM');
          return `${startDate}-${endDate}`;
        },
      },
    },
  },
  plugins: {
    tooltip: {
      callbacks: {
        title: (tooltipItems) => {
          const index = tooltipItems[0].dataIndex;
          const week = moment(weeksBackwards[index]);
          const startDate = week.startOf('week').format('DD MMM');
          const endDate = week.endOf('week').format('DD MMM');
          return `${startDate} - ${endDate}`; 
        },
        label: (context) => {
          const value = context.parsed.y;
          return `${value  }${value > 1 ? ' events' : ' event'}`;
        }
      }
    }
  }
};
